<template>
  <div class="mian_view">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <div class="main">
      <h2>学习记录</h2>
      <ul>
        <li>
          <p>学员名称：</p>
          <p>张三</p>
        </li>
        <li>
          <p>科室：</p>
          <p>张三</p>
        </li>
        <li>
          <p>职位：</p>
          <p>张三</p>
        </li>
        <li>
          <p>总学习时长：</p>
          <p>张三</p>
        </li>
      </ul>
    </div>
    <div class="examinee_form" v-loading="loading">
      <el-table
        ref="tabledata"
        :data="getData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="370">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                @click.stop="detailRecord(scope.row)"
                type="text"
                size="small"
                >详细记录</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getData: [],
      formColumns: [
        {
          prop: "name",
          label: "视频名称",
          // width: "90px",
        },
        {
          prop: "taskStatus",
          label: "最近学习时间",
          // width: "90px",
        },
        {
          prop: "isLock2",
          label: "视频时长",
          // width: "90px",
        },
        {
          prop: "videoNum",
          label: "总学习时长",
          width: "100px",
        },
        {
          prop: "stuNum",
          label: "是否完成",
          // width: "90px",
        },
      ],
    };
  },
  props: ["cutcoms"],
  methods: {
    // 返回按键
    backBtn() {
      this.$destroy();
      this.cutcoms(2);
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.mian_view {
  // height: 100%;
  width: 100%;
  min-height: 780px;
  padding-bottom: 46px;
  // padding: 24px !important;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.main {
  padding: 24px;
}
ul {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  li {
    display: flex;
    margin-right: 24px;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.el-button--text {
  font-size: 16px;
}
::v-deep .cell {
  text-align: center;
}
.examinee_form {
  min-height: 560px;
  padding: 24px;
}
</style>